export const APP_LANGUAGE = 'app_language'
